import {getServiceEnvironment} from './getServiceEnvironment';

/**
 * Returns the Link app domain based on the brand name.
 * Defaults to 'link' if no brand name is provided.
 *
 * @param linkBrandName - Optional brand name (e.g., 'Link', 'Onelink')
 * @returns The brand domain (e.g., 'link.com', 'onelink.com')
 */
const getLinkBrandDomain = (linkBrandName?: string): string => {
  if (!linkBrandName) {
    return 'link.com';
  }
  return `${linkBrandName.toLowerCase()}.com`;
};

/**
 * Returns the base URL for the Link app based on the current environment and optional brand name.
 *
 * @param linkBrandName - Optional brand name (e.g., 'Link', 'Onelink') to derive the correct app URL
 * @returns The Link app base URL for the current environment, or null if environment is invalid
 */
export const getLinkAppBaseUrl = (linkBrandName?: string): string | null => {
  const env = getServiceEnvironment();
  const {hostname} = window.location;
  const brandDomain = getLinkBrandDomain(linkBrandName);

  switch (env) {
    case 'prod':
    case 'preprod':
      return `https://app.${brandDomain}`;
    case 'qa':
    case 'isolated_qa':
      return `https://qa-app.${brandDomain}`;
    case 'devbox':
      // Extract dev box username from hostname for dev environment
      const match = hostname.match(/^([^-]+(?:-[^-]+)+)--/);
      const devBoxUserName = match ? match[0] : null;

      return `https://${devBoxUserName}link_app_frontend-mydev.dev.stripe.me`;
    default:
      return null;
  }
};
